import React, { PureComponent } from "react";
import "./workExperience.scss";
import CompanyList from "./companyList";
import WorkExpItem from "./workExperienceItem";
import PropTypes from 'prop-types'

class WorkExperience extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      details: undefined,
    };
  }

  componentDidMount() {
    this.setState({
      details: this.props.workExperience[0],
    });
  }

  onCompanyClick = (event) => {
    const selectedCompany = event.target.id;
    const selectedCompanyDetails = this.props.workExperience.filter(
      (work) => work.companyName === selectedCompany
    )[0];
    this.setState({ details: selectedCompanyDetails });
  };

  render() {
    if (this.state.details) {
      return (
        <div>
          <section id="work-experience">
            <h1 className="pb-md-4 title-2 title-md-2">My work experience</h1>
            <div className="d-flex justify-content-between">
              <CompanyList
                companyName={this.state.details.companyName}
                workExperience={this.props.workExperience}
                onCompanyClick={this.onCompanyClick}
              />
              <WorkExpItem job={this.state.details} />
            </div>
            <div className="d-flex justify-content-center pt-md-5">
              <a href="#side-projects" className="btn-view-my-work">
                My side projects
              </a>
            </div>
          </section>
        </div>
      );
    } else {
      return <div></div>;
    }
  }
}

WorkExperience.propTypes = {
  workExperience: PropTypes.array.isRequired,
};

export default WorkExperience;
